import { SECTION_STATE } from '@/constants';
import { atomWithUniqueKey } from '@/utils';

export type SectionName = 'home' | 'termsForm' | 'responsibleForm';

export type SectionState = {
  current: SectionName;
};

export const useSectionState = atomWithUniqueKey<SectionState>({
  key: SECTION_STATE,
  default: { current: 'home' },
});
